const CommunicationType = {
    RADIO: 'radio',
    TV: 'tv',
    PRESS: 'press',
    INTERNET: 'internet',
    FRIEND: 'friend',
    FACEBOOK: 'facebook',
    LINKEDIN: 'linkedin',
    TWITTER: 'twitter',
    AD_BOARD: 'ad-board',
    OTHER: 'other'
};

module.exports = CommunicationType;